import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M19.5 12.497C19.224 12.497 19 12.721 19 12.997C19 16.857 15.859 19.997 12 19.997C8.141 19.997 5 16.856 5 12.997C5 9.13797 8.14 5.99698 12 5.99698C12.455 5.99698 12.903 6.05598 13.345 6.14198L11.146 8.33998C10.951 8.53498 10.951 8.85198 11.146 9.04698C11.244 9.14498 11.372 9.19298 11.5 9.19298C11.628 9.19298 11.756 9.14398 11.854 9.04698L14.854 6.04698C15.049 5.85198 15.049 5.53498 14.854 5.33998L11.854 2.33998C11.659 2.14498 11.342 2.14498 11.147 2.33998C10.952 2.53498 10.952 2.85198 11.147 3.04698L13.189 5.08898C12.797 5.03098 12.4 4.99698 12 4.99698C7.589 4.99698 4 8.58598 4 12.997C4 17.408 7.589 20.997 12 20.997C16.411 20.997 20 17.408 20 12.997C20 12.72 19.776 12.497 19.5 12.497Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Reload');

export default Icon;
